module.exports = __webpack_public_path__ + "media/images/registration-mobile-632ffa19ad01db3072e677ca4422848a.jpg";